import {
  ClickAwayListener,
  Grow,
  MenuItem,
  MenuList,
  Popper,
  Theme,
  Typography,
  useMediaQuery,
} from "@material-ui/core";
import { createStyles, makeStyles } from "@material-ui/core/styles";
import RequesterImage from "assets/images/group-1548.svg";
import { theme } from "config/theme";
import useText from "constants/text";
import React from "react";
import { useNavigate } from "react-router-dom";
import "styled-components/macro";
import { Button } from "ui/Button";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: "flex",
      height: 125,
      backgroundColor: "#fff",
      borderRadius: 14,
      marginBottom: 20,
      justifyContent: "space-between",
      width: "100%",
      [theme.breakpoints.down("xs")]: {
        height: "95px",
        marginBottom: 1,
        marginTop: 65,
        width: "100vw",
        marginLeft: "-4px",
      },
    },
    slogan: {
      display: "flex",
      justifyContent: "space-evenly",
    },
    newRequest: {
      marginTop: "auto",
      marginBottom: "auto",
      marginLeft: 15,
      [theme.breakpoints.down("xs")]: {},
    },
    spacing: {
      marginTop: "auto",
      marginBottom: "auto",
      marginLeft: 15,
      [theme.breakpoints.down("xs")]: {
        marginTop: "auto",
        marginBottom: "auto",
      },
    },
    img: {
      marginBottom: "10px",
      height: "140px",
      objectFit: "contain",
      [theme.breakpoints.down("xs")]: {
        height: 100,
      },
    },
    typography: {
      fontSize: "26px",
      fontWeight: 600,
      lineHeight: 1.39,
      color: "rgba(117, 122, 147, 0.64)",
      [theme.breakpoints.down("xs")]: {
        fontSize: 16,
        display: "none",
      },
    },
    typography1: {
      fontSize: "26px",
      fontStretch: "normal",
      fontStyle: "normal",
      lineHeight: 1.39,
      color: "rgba(117, 122, 147, 0.64)",
      [theme.breakpoints.down("xs")]: {
        fontSize: 16,
        display: "none",
      },
    },
    popper: {
      top: "160px !important",
      left: "30px !important",
      background: "#fff !important",
      width: "189px",
      [theme.breakpoints.down("xs")]: {
        top: "127px !important",
        left: "16px !important",
        borderRadius: "4px",
        zIndex: 1,
      },
    },
  })
);
export interface RequestHeaderProps {
  showButton?: boolean;
}

export function RequestHeader({ showButton = false }: RequestHeaderProps) {
  const styles = useStyles();
  const { text } = useText();
  const anchorRef = React.useRef<HTMLDivElement>(null);
  const [open, setOpen] = React.useState(false);
  const ref = React.useRef(null);
  const navigator = useNavigate();
  const smallScreen = useMediaQuery(theme.breakpoints.down("xs"));

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };
  const handleClose = (event: React.MouseEvent<Document, MouseEvent>) => {
    if (anchorRef.current && anchorRef.current.contains(event.target as HTMLElement)) {
      return;
    }
    setOpen(false);
  };
  const handleAction = (key: string) => {
    switch (key) {
      case "1":
        navigator("/tracking/request/samapapser");
        setOpen(false);
        break;
      case "2":
        navigator("/national-transport");
        setOpen(false);
        break;
      case "3":
        navigator("/tracking/request/tour");
        setOpen(false);
        break;
      default:
        break;
    }
  };

  const typeOfRequests = [
    {
      label: text?.requestQuote.samapaser,
      key: "1",
      disabled: process.env.REACT_APP_SAMA_PAPSER_DISABLED_CHECK === "true",
    },
    {
      label: text?.requestQuote.national_transport,
      key: "2",
      disabled: process.env.REACT_APP_TRANSPORT_NATIONAL_DISABLED_CHECK === "true",
    },
    {
      label: text?.requestQuote.tour,
      key: "3",
      disabled: process.env.REACT_APP_PAPS_TOUR_DISABLED_CHECK === "true",
    },
  ];

  return (
    <div className={styles.root}>
      <div className={styles.slogan}>
        <div className={styles.newRequest}>
          <Button variant="contained" onClick={handleToggle} color="primary">
            {text.requestQuote.new_request}
          </Button>
          <Popper
            open={open}
            anchorEl={anchorRef.current}
            role={undefined}
            transition
            ref={ref}
            className={styles.popper}
          >
            {({ TransitionProps, placement }) => (
              <Grow
                {...TransitionProps}
                style={{
                  transformOrigin: placement === "bottom" ? "center top" : "center bottom",
                }}
              >
                <ClickAwayListener onClickAway={handleClose}>
                  <MenuList id="split-button-menu">
                    {typeOfRequests.map((action) => (
                      <MenuItem
                        key={action.key}
                        style={{ padding: 5 }}
                        onClick={() => handleAction(action.key)}
                        disabled={action.disabled}
                      >
                        {action.label}
                      </MenuItem>
                    ))}
                  </MenuList>
                </ClickAwayListener>
                {/* <Paper>
                  <ClickAwayListener onClickAway={handleClose}>
                    <MenuList id="split-button-menu">
                      {typeOfRequests.map((action) => (
                        <MenuItem key={action.key} style={{ padding: 5 }} onClick={() => handleAction(action.key)}>
                          {action.label}
                        </MenuItem>
                      ))}
                    </MenuList>
                  </ClickAwayListener>
                </Paper> */}
              </Grow>
            )}
          </Popper>
        </div>
        <div className={styles.spacing}>
          <Typography variant="h3" className={styles.typography1}>
            {text.all.to_have_a_global_view_on_your}
          </Typography>
        </div>
        <div className={styles.spacing}>
          <Typography variant="h1" className={styles.typography}>
            {text.all.requests}
          </Typography>
        </div>
      </div>
      <div>
        <img src={RequesterImage} className={styles.img} alt="box images" />
      </div>
    </div>
  );
}
